import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AngularMaterialModule } from 'src/app/material.module';  
import { FormsModule } from '@angular/forms';
import { ProcessComponent } from '../process/process.component';
import { PipeModule } from 'src/app/shared/pipes/pipes.module';

@NgModule({
  imports: [
    CommonModule,AngularMaterialModule,FormsModule,
    PipeModule
  ],
  declarations: [ProcessComponent],
  exports: [ProcessComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class ProcessModule { }
